import { z } from 'zod';
export const healthzResponseSchema = z.object({
    status: z.literal('ok'),
    version: z.string(),
    uptimeSeconds: z.number().nonnegative(),
});
export const readyzResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    checks: z.object({
        database: z.enum(['ok', 'fail']),
        media: z.enum(['ok', 'fail']),
    }),
});
//# sourceMappingURL=health.js.map